import { render, staticRenderFns } from "./block-card.vue?vue&type=template&id=17750b02&scoped=true&"
import script from "./block-card.vue?vue&type=script&lang=ts&"
export * from "./block-card.vue?vue&type=script&lang=ts&"
import style0 from "./block-card.vue?vue&type=style&index=0&id=17750b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17750b02",
  null
  
)

export default component.exports